var _path, _path2, _g, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEagle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m471.95 253.05c0 120.9-98.006 218.9-218.9 218.9-120.9 0-218.9-98.006-218.9-218.9 0-120.9 98.006-218.9 218.9-218.9 120.9 0 218.9 98.006 218.9 218.9z",
    fill: "#c50e0e",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m282.94 108.44c-15.702 15.223-21.157 39.192-33.469 57.469-10.735 10.771-24.993 39.575-39.312 29.125-6.5227 6.3513-7.9933 23.084-16.531 10.125-11.553 18.628-27.631 42.099-21.5 65.062 7.7782 12.246 35.437 26.653 3.75 28.031-16.82 10.288-32.938 32.991-25.75 52.75 9.7982 9.8169 19.647 19.583 29.406 29.438-16.235 9.4743-6.7162 21.646 4.25 29.938 20.492 20.456 40.958 40.935 61.438 61.406 2.6014.0915 5.1888.1875 7.8125.1875 120.9 0 218.91-98.01 218.91-218.91 0-.18783.00047-.37478 0-.5625-47.34-47.289-94.678-94.577-141.91-141.97-13.988-.74985-4.0691 36.507-27.711 16.299-2.7341-2.3369-5.6553-5.4784-9.3198-9.1429-3.4435-2.786-6.2138-7.4131-10.062-9.25z",
    fillOpacity: 0.23529
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256 1c-140.83 0-255 114.17-255 255s114.17 255 255 255 255-114.17 255-255-114.17-255-255-255zm8.8269 44.931c120.9 0 218.9 97.999 218.9 218.9s-97.999 218.9-218.9 218.9-218.93-97.999-218.93-218.9 98.029-218.9 218.93-218.9z",
    fillOpacity: 0.066667
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 4.4327c-138.94 0-251.57 112.63-251.57 251.57.0027 138.94 112.63 251.57 251.57 251.57s251.57-112.63 251.57-251.57-112.63-251.57-251.57-251.57zm5.8846 38.556c120.9 0 218.9 97.999 218.9 218.9s-97.999 218.9-218.9 218.9-218.93-97.999-218.93-218.9 98.029-218.9 218.93-218.9z",
    fillOpacity: 0.12941
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 8.3558c-136.77 0-247.64 110.87-247.64 247.64-.0042 136.77 110.87 247.64 247.64 247.64s247.64-110.87 247.64-247.64-110.87-247.64-247.64-247.64zm2.9423 31.691c120.9 0 218.9 97.999 218.9 218.9s-97.999 218.9-218.9 218.9-218.93-97.999-218.93-218.9 98.029-218.9 218.93-218.9z",
    fillOpacity: 0.12941
  }), /*#__PURE__*/React.createElement("path", {
    d: "m253.04 7.8591c-135.42 0-245.19 109.78-245.19 245.19 0 135.42 109.78 245.19 245.19 245.19 135.42 0 245.19-109.78 245.19-245.19 0-135.42-109.78-245.19-245.19-245.19zm0 26.297c120.9 0 218.9 97.999 218.9 218.9s-97.999 218.9-218.9 218.9-218.93-97.999-218.93-218.9 98.029-218.9 218.93-218.9z",
    fill: "#fff",
    stroke: "#000",
    strokeOpacity: 0.3098,
    strokeWidth: 4.9038
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 729.6424,
    y: 231.35828
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 729.6424,
    y: 231.35828
  }))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 378.90738,
    y: 579.25208
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 1310.9095,
    y: 151.35626
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1310.9095,
    y: 151.35626
  }))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 523.75934,
    y: 258.21695
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 239.33031,
    y: -29.900511
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 239.33031,
    y: -29.900511
  }))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 256.72147,
    y: -469.13681
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 1337.3806,
    y: -246.37442
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1337.3806,
    y: -246.37442
  }))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 530.35596,
    y: -1337.811
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 1918.6478,
    y: -326.37643
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1918.6478,
    y: -326.37643
  }))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 675.20789,
    y: -1658.8459
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 1529.527,
    y: -798.776
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1529.527,
    y: -798.776
  }))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 578.23883,
    y: -3554.5081
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 2110.7942,
    y: -878.77802
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2110.7942,
    y: -878.77802
  }))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 723.09082,
    y: -3875.543
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 277.98608,
    y: 535.93591
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 277.98608,
    y: 535.93591
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m178.62 401.6c-.68885-1.7951-3.0181-3.2639-5.1761-3.2639-2.5418 0-3.9236-1.4599-3.9236-4.1453 0-2.2799.78299-4.1454 1.74-4.1454.95698 0 2.7737-2.2687 4.0371-5.0416 1.6207-3.557 5.6402-6.0954 13.65-8.6202 12.176-3.8383 13.656-5.976 13.708-19.804.0228-6.0752-1.409-8.8197-7.2982-13.991-4.3578-3.8262-9.6068-6.4296-12.954-6.425-7.5963.0104-18.756 7.1077-21.173 13.466-2.332 6.1337-6.3352 6.6311-11.089 1.3779-2.8854-3.1884-3.1154-5.5228-1.4231-14.446 3.415-18.007 16.64-34.46 33.24-41.354 3.9899-1.657 7.6304-3.3686 8.0902-3.8034.45968-.43487-3.4301-4.7672-8.644-9.6274-15.34-14.3-15.224-23.339.73969-57.404 9.6332-20.557 12.823-23.687 14.342-14.075l1.0558 6.6804 4.7477-9.6775c2.6113-5.3226 6.1473-10.839 7.858-12.259 2.5808-2.1419 3.3099-1.8176 4.2834 1.905.64522 2.4674 1.393 4.4862 1.6618 4.4862.26872 0 7.5573-6.8876 16.197-15.306 14.307-13.94 17.062-18.055 30.878-46.114 9.8466-19.998 16.442-31.044 18.797-31.481 2.8753-.53365 3.6083.75464 3.5362 6.215-.05 3.7885-1.4351 10.619-3.0778 15.179-6.0398 16.765-4.1568 16.565 18.931-2.008 20.731-16.677 29.836-21.232 29.836-14.927 0 1.5157-5.1962 8.4978-11.547 15.516l-11.547 12.76 12.937-7.3122c26.39-14.916 28.463-9.5037 5.9692 15.584l-16.885 18.832 12.091-5.4909c6.6503-3.02 16.424-7.1989 21.719-9.2864l9.6273-3.7955-1.0996 4.5723c-1.4941 6.2128-9.5317 14.526-22.997 23.788l-11.239 7.7294 13.853 1.3941c7.6191.76678 15.297 2.5927 17.062 4.0576 2.8542 2.3687 2.7016 3.0745-1.3785 6.3784-2.5233 2.0432-6.8162 3.715-9.5398 3.715-3.5221 0-4.9521 1.163-4.9521 4.0278 0 2.2153-1.8935 5.3541-4.2078 6.9751-4.1682 2.9195-4.1585 2.9795 1.0363 6.3833 6.5332 4.2807 6.6455 8.4397.38649 14.321-3.8853 3.6508-4.6692 6.1242-3.9163 12.356.51771 4.2855 1.6564 8.2337 2.5304 8.7738 2.4431 1.5099-.53016 12.297-5.1561 18.707-2.2799 3.1591-7.2138 8.9918-10.964 12.962-3.7503 3.9698-6.3233 7.7133-5.7178 8.3188 2.6634 2.6634-4.1988 6.664-11.431 6.664-4.353 0-8.5788 1.0748-9.3906 2.3883-2.0265 3.2789 11.818 1.0184 34.872-5.6937 22.475-6.5436 29.323-6.1471 30.232 1.7508.36071 3.1349 1.5266 5.6998 2.5908 5.6998s1.935 1.4864 1.935 3.303c0 1.8167 1.8654 3.7908 4.1454 4.3871 3.2222.84262 4.1453 2.8272 4.1453 8.9112 0 5.1412-1.0971 8.2482-3.197 9.054-1.7583.67474-13.883 2.3102-26.945 3.6344-13.061 1.3242-23.748 3.3096-23.748 4.412 0 1.201-3.7384 1.4438-9.327.60572-9.2725-1.3905-11.468.0311-6.9791 4.5195 3.596 3.596.46888 8.8445-5.2695 8.8445-2.8184 0-5.74.99605-6.4924 2.2134-.75238 1.2174-4.7391 1.923-8.8593 1.568-6.5154-.56132-7.9057.15835-10.672 5.5246-4.4054 8.5451-8.2887 11.278-16.135 11.355-4.1458.0406-6.7362 1.1123-6.7362 2.7871 0 1.4967-2.7129 5.3203-6.0286 8.497-4.961 4.7529-7.1633 5.5265-12.436 4.3684-5.051-1.1094-6.4074-.71427-6.4074 1.8664 0 1.8006-1.3362 3.2737-2.9693 3.2737s-3.5614 1.8654-4.285 4.1453c-1.5689 4.9432-3.753 5.2552-7.2544 1.0363-3.5664-4.2973-8.814-3.888-15.271 1.1912-4.767 3.7497-5.6271 3.8824-6.7193 1.0363z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEagle);
export default __webpack_public_path__ + "static/media/eagle.75e084e88110d068e03866a77f9386a0.svg";
export { ForwardRef as ReactComponent };